import { memo } from "react";
import { Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useAuth } from "../hooks/useAuth";
import CustomLayout from "./CustomLayout";
import AdminCheckoutLayout from "./AdminCheckoutLayout";

const ProtectedRoutes = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }
  if (user.admin_plan?.plan_type === "admin_checkout") {
    return <AdminCheckoutLayout>{children}</AdminCheckoutLayout>;
  } else {
    return <CustomLayout>{children}</CustomLayout>;
  }
};

export default memo(ProtectedRoutes);
